import { takeLatest, put, call, select } from 'redux-saga/effects';
import OtActions, { OtTypes } from '../Redux/OtRedux';
import ApiResponseError from '../Services/ApiResponseError';
import OtAttributeTypes from '../Enum/OtAttributeTypes';

export function * getOts(api, action) {
    try {
        const response = yield call(api.getOtCollection, action.query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        const data = response.data.data;
        const pagination = data.pagination ? data.pagination : null;

        yield put(OtActions.fetchOtsSuccess(data.ots, pagination));

        // This is just an stupid hack for fullcalendar to work with redux
        if (action.callback){
            action.callback(data.ots);
        }
    } catch (e) {
        yield put(OtActions.fetchOtsFailure(e));
    }
}

export function * getFlatOts(api, action) {
    try {
        const response = yield call(api.getOtCollection, action.query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchFlatOtsSuccess(response.data.data.ots));
    } catch (e) {
        yield put(OtActions.fetchFlatOtsFailure(e));
    }
}

export function * createOt(api, {ot, query}) {
    try {
        const response = yield call(api.postOtCollection, ot, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtSuccess(response.data.data.ot));
    } catch (e) {
        yield put(OtActions.createOtFailure(e));
    }
}

export function * getOt(api, { ot_uuid, query }) {
    try {
        const response = yield call(api.getOtResource, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtSuccess(response.data.data.ot));
    } catch (e) {
        yield put(OtActions.fetchOtFailure(e));
    }
}

export function * updateOt(api, {ot_uuid, ot, query}) {
    try {
        const response = yield call(api.patchOtResource, ot_uuid, ot, query);

        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        yield put(OtActions.updateOtSuccess(response.data.data.ot, response.data.data.ot_details));
    } catch (e) {
        yield put(OtActions.updateOtFailure(e));
    }
}

export function * deleteOt(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.deleteOtResource, ot_uuid );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtSuccess(response.data.data.ots));
        yield call(getOts, api, {query});
    } catch (e) {
        yield put(OtActions.deleteOtFailure(e));
    }
}

/** OT details */
export function * createOtDetail(api, { ot_uuid, detail, query }) {
    try {
        const response = yield call(api.postOtDetailCollection, ot_uuid, detail, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtDetailSuccess(response.data.data.detail, response.data.data.ot_details));

        yield call(getOtDetails, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.createOtDetailFailure(e));
    }
}

export function * updateOtDetail(api, { uuid, detail, query, ot_uuid }) {
    try {
        const response = yield call(api.patchOtDetailResource, uuid, detail, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.updateOtDetailSuccess(response.data.data.detail, response.data.data.ot_details));

        yield call(getOtDetails, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.updateOtDetailFailure(e));
    }
}

export function * getOtDetails(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.getOtDetailsCollection, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtDetailsSuccess(response.data.data.details, response.data.data.total, response.data.data.ot_details));
    } catch (e) {
        yield put(OtActions.fetchOtDetailsFailure(e));
    }
}

export function * deleteOtDetail(api, {detail_uuid, ot_uuid, query}) {
    try {
        const response = yield call(api.deleteOtDetailResource, detail_uuid );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtDetailSuccess(response.data.data.ot_details));

        yield call(getOtDetails, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.deleteOtDetailFailure(e));
    }
}


/** OT transactions */
export function * createOtTransaction(api, { ot_uuid, transaction, query }) {
    try {
        const response = yield call(api.postOtTransactionCollection, ot_uuid, transaction, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtTransactionSuccess(response.data.data.transaction));

        yield call(getOtTransactions, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.createOtTransactionFailure(e));
    }
}

export function * getOtTransactions(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.getOtTransactionsCollection, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtTransactionsSuccess(response.data.data.transactions, response.data.data.total));
    } catch (e) {
        yield put(OtActions.fetchOtTransactionsFailure(e));
    }
}

export function * deleteOtTransaction(api, {transaction_id, ot_uuid, query}) {
    try {
        const response = yield call(api.deleteOtTransactionResource, transaction_id );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtTransactionSuccess());

        yield call(getOtTransactions, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.deleteOtTransactionFailure(e));
    }
}


/** OT assets */
export function * createOtAsset(api, { ot_uuid, asset, query }) {
    try {
        const response = yield call(api.postOtAssetCollection, ot_uuid, asset, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtAssetSuccess(response.data.data.asset));

        yield call(getOtAssets, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.createOtAssetFailure(e));
    }
}

export function * getOtAssets(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.getOtAssetsCollection, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtAssetsSuccess(response.data.data.assets));
    } catch (e) {
        yield put(OtActions.fetchOtAssetsFailure(e));
    }
}

export function * deleteOtAsset(api, {asset_id, ot_uuid, query}) {
    try {
        const response = yield call(api.deleteOtAssetResource, ot_uuid, asset_id );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtAssetSuccess());

        yield call(getOtAssets, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.deleteOtAssetFailure(e));
    }
}

export function * createQuote(api, { quote, query }) {
    try {
        const response = yield call(api.postQuoteCollection, quote, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createQuoteSuccess(response.data.data.quote));
    } catch (e) {
        yield put(OtActions.createQuoteFailure(e));
    }
}

export function * notify(api, {ot_uuid, message}) {
    try {
        const response = yield call(api.postQuoteNotificationCollection, ot_uuid, message);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.notifySuccess());
    } catch (e) {
        yield put(OtActions.notifyFailure(e));
    }
}

/** OT discounts */
export function * createOtDiscount(api, { ot_uuid, discount, query }) {
    try {
        const response = yield call(api.postOtDiscountCollection, ot_uuid, discount, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtDiscountSuccess(response.data.data.discount));

        yield call(getOtDiscounts, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.createOtDiscountFailure(e));
    }
}

export function * getOtDiscounts(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.getOtDiscountsCollection, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtDiscountsSuccess(response.data.data.discounts, response.data.data.total));
    } catch (e) {
        yield put(OtActions.fetchOtDiscountsFailure(e));
    }
}

export function * deleteOtDiscount(api, {discount_id, ot_uuid, query}) {
    try {
        const response = yield call(api.deleteOtTransactionResource, discount_id );
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtDiscountSuccess());

        yield call(getOtDiscounts, api, {ot_uuid, query});
    } catch (e) {
        yield put(OtActions.deleteOtDiscountFailure(e));
    }
}

export function * getOtAttributes(api, {ot_uuid, query = {type: OtAttributeTypes.external_resource_url}}) {
    try {
        const response = yield call(api.getOtAttributes, ot_uuid, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.fetchOtAttributesSuccess(response.data.data.attributes));
    } catch (e) {
        yield put(OtActions.fetchOtAttributesFailure(e));
    }
}

export function * createOtAttribute(api, { ot_uuid, attribute, query, onFinish }) {
    try {
        const response = yield call(api.createOtAttribute, ot_uuid, attribute, query);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createOtAttributeSuccess(response.data.data.discount));

        yield call(getOtAttributes, api, {ot_uuid, query});

        if (onFinish) {
            onFinish();
        }
    } catch (e) {
        yield put(OtActions.createOtAttributeFailure(e));
    }
}

export function * deleteOtAttribute(api, {attribute_id, ot_uuid}) {
    try {
        const response = yield call(api.deleteOtAttribute, attribute_id, ot_uuid);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.deleteOtAttributeSuccess());

        yield call(getOtAttributes, api, {ot_uuid});
    } catch (e) {
        yield put(OtActions.deleteOtAttributeFailure(e));
    }
}

export function * createQuickQuote(api, {data}) {
    try {
        const response = yield call(api.createQuickQuote, data);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createQuickQuoteSuccess(response.data.data.quote));
    } catch (e) {
        yield put(OtActions.createQuickQuoteFailure(e));
    }
}

export function * createQuickOt(api, {data}) {
    try {
        const response = yield call(api.createQuickOt, data);
        if (!response.ok) {
            throw new ApiResponseError(response);
        }
        yield put(OtActions.createQuickOtSuccess(response.data.data.ot));
    } catch (e) {
        yield put(OtActions.createQuickOtFailure(e));
    }
}

export function * confirmQuote(api, {ot_uuid, query}) {
    try {
        const response = yield call(api.patchOtResource, ot_uuid, {confirm: true}, query);

        if (!response.ok) {
            throw new ApiResponseError(response);
        }

        window.location.href = `/ot/${response.data.data.related_ot.uuid}/edit`;
    } catch (e) {
        yield put(OtActions.updateOtFailure(e));
    }
}

export function * watchOt(api) {
    yield takeLatest(OtTypes.FETCH_FLAT_OTS, getFlatOts, api);
    yield takeLatest(OtTypes.FETCH_OTS, getOts, api);
    yield takeLatest(OtTypes.CREATE_OT, createOt, api);
    yield takeLatest(OtTypes.FETCH_OT, getOt, api);
    yield takeLatest(OtTypes.UPDATE_OT, updateOt, api);
    yield takeLatest(OtTypes.DELETE_OT, deleteOt, api);

    yield takeLatest(OtTypes.FETCH_OT_DETAILS, getOtDetails, api);
    yield takeLatest(OtTypes.CREATE_OT_DETAIL, createOtDetail, api);
    yield takeLatest(OtTypes.UPDATE_OT_DETAIL, updateOtDetail, api);
    yield takeLatest(OtTypes.DELETE_OT_DETAIL, deleteOtDetail, api);

    yield takeLatest(OtTypes.FETCH_OT_TRANSACTIONS, getOtTransactions, api);
    yield takeLatest(OtTypes.CREATE_OT_TRANSACTION, createOtTransaction, api);
    yield takeLatest(OtTypes.DELETE_OT_TRANSACTION, deleteOtTransaction, api);

    yield takeLatest(OtTypes.FETCH_OT_ASSETS, getOtAssets, api);
    yield takeLatest(OtTypes.CREATE_OT_ASSET, createOtAsset, api);
    yield takeLatest(OtTypes.DELETE_OT_ASSET, deleteOtAsset, api);

    yield takeLatest(OtTypes.FETCH_OT_DISCOUNTS, getOtDiscounts, api);
    yield takeLatest(OtTypes.CREATE_OT_DISCOUNT, createOtDiscount, api);
    yield takeLatest(OtTypes.DELETE_OT_DISCOUNT, deleteOtDiscount, api);

    yield takeLatest(OtTypes.CREATE_QUOTE, createQuote, api);
    yield takeLatest(OtTypes.NOTIFY, notify, api);

    yield takeLatest(OtTypes.FETCH_OT_ATTRIBUTES, getOtAttributes, api);
    yield takeLatest(OtTypes.CREATE_OT_ATTRIBUTE, createOtAttribute, api);
    yield takeLatest(OtTypes.DELETE_OT_ATTRIBUTE, deleteOtAttribute, api);

    yield takeLatest(OtTypes.CREATE_QUICK_QUOTE, createQuickQuote, api);
    yield takeLatest(OtTypes.CREATE_QUICK_OT, createQuickOt, api);

    yield takeLatest(OtTypes.CONFIRM_QUOTE, confirmQuote, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/OtSagas.js